import type { ExperimentFeatureFlags } from '@cosuno/feature-flags';
import { createContext } from 'react';

export const PROVIDER_DOESNT_EXIST = Symbol("ExperimentFlagsContext provider doesn't exist");

export const ExperimentFlagsContext = createContext<
  Readonly<ExperimentFeatureFlags> | false | null | undefined | typeof PROVIDER_DOESNT_EXIST
>(PROVIDER_DOESNT_EXIST);

/**
 * Provider necessary for the hook `useExperimentFlags` to work.
 *
 * Mount this provider close to the root of the application and pass experiment
 * feature flags you receive from the API.
 *
 * Passing a falsy value in will cause feature flag defaults to be returned from
 * `useExperimentFlags`.
 */
export const ExperimentFlagsProvider = ExperimentFlagsContext.Provider;
